import { Link } from "react-router-dom";
import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { List } from "@/components/admin/list";
import { SearchInput } from "@/components/admin/search-input";
import { Badge } from "@/components/ui/badge";

import type { PosterEmailCapture } from "../types";

/**
 * "Poster Emails" — every address a user asked their HD poster emailed to,
 * with how many posters have been sent there. One row per (contact, email),
 * projected by the dashboard-indexer from `poster.hd_email.sent` events and
 * stored under the contact's own partition so GDPR deletion covers it.
 * Admin-only (raw PII) via canAccess.
 */
const posterEmailFilters = [<SearchInput source="q" alwaysOn />];

export const PosterEmailsList = () => {
  return (
    <List
      title="Poster Emails"
      perPage={25}
      sort={{ field: "last_sent_at", order: "DESC" }}
      filters={posterEmailFilters}
    >
      <DataTable<PosterEmailCapture> bulkActionButtons={false}>
        <DataTable.Col
          source="email"
          label="Email"
          render={(record) => (
            <a
              href={`mailto:${record.email}`}
              className="underline-offset-2 hover:underline"
            >
              {record.email}
            </a>
          )}
        />
        <DataTable.Col
          source="whatsapp_user_id"
          label="Contact"
          render={(record) =>
            record.contact_id ? (
              <Link
                to={`/contacts/${encodeURIComponent(String(record.contact_id))}/show`}
                className="underline-offset-2 hover:underline"
              >
                {record.whatsapp_user_id}
              </Link>
            ) : (
              record.whatsapp_user_id
            )
          }
        />
        <DataTable.Col
          source="sent_count"
          label="Posters sent"
          render={(record) => (
            <Badge variant="secondary">{record.sent_count ?? 0}</Badge>
          )}
        />
        <DataTable.Col source="first_sent_at" label="First sent">
          <DateField source="first_sent_at" showTime />
        </DataTable.Col>
        <DataTable.Col source="last_sent_at" label="Last sent">
          <DateField source="last_sent_at" showTime />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};
